import React, { useState } from 'react';

// The tablet's PIN pad (guided P&P, 2026-10-17). Fernando: "The safest is that they pick the cart they want and enter
// their PIN" — every round, and to resume after a pause or take a round over. Big keys for a cart in the aisles;
// the PIN is never shown, only dots. The server counts wrong tries and locks after 5 (pp_identity).

export default function PinPad({ title, hint, error, busy, onSubmit, onCancel, cancelLabel }: {
  title: string; hint?: string; error?: string; busy?: boolean; cancelLabel: string;
  onSubmit: (pin: string) => void; onCancel: () => void;
}) {
  const [pin, setPin] = useState('');
  const press = (d: string) => {
    if (busy) return;
    const next = (pin + d).slice(0, 4);
    setPin(next);
    if (next.length === 4) { onSubmit(next); setTimeout(() => setPin(''), 300); }
  };
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', '⌫'];
  return (
    <div className="flex flex-col items-center gap-5 py-6">
      <div className="text-2xl font-bold text-[#111111] text-center">{title}</div>
      {hint && <div className="text-lg text-[#444444] text-center -mt-2 flex items-center gap-2"><span aria-hidden>▮▮▮</span>{hint}</div>}
      <div className="flex gap-4">
        {[0, 1, 2, 3].map(i => (
          <span key={i} className={`w-5 h-5 rounded-full border-2 border-[#111111] ${i < pin.length ? 'bg-[#111111]' : ''}`} />
        ))}
      </div>
      {error && <div className="text-red-700 text-lg font-semibold text-center max-w-md">{error}</div>}
      <div className="grid grid-cols-3 gap-3">
        {keys.map((k, i) => k === '' ? <span key={i} /> : (
          <button key={i} disabled={busy}
            onClick={() => (k === '⌫' ? setPin(p => p.slice(0, -1)) : press(k))}
            className="w-24 h-20 rounded-2xl bg-white border border-[#9aa0a6] text-3xl font-bold text-[#111111] active:bg-[#e5e7eb] disabled:opacity-40">
            {k}
          </button>
        ))}
      </div>
      <button onClick={onCancel} className="mt-2 px-6 py-3 rounded-xl bg-white border border-[#9aa0a6] text-lg text-[#111111]">{cancelLabel}</button>
    </div>
  );
}
